import { getHandler, deleteHandler } from 'src/utils/fetchHandler';
import { getPendingReminderDelete } from './reminder.selector';

export const CLEAR_REMINDERS = 'CLEAR_REMINDERS/REMINDER/@WISELY/WEB';
export const GET_REMINDERS = 'GET_REMINDERS/REMINDER/@WISELY/WEB';
export const FETCH_REMINDERS_FAILED = 'FETCH_REMINDERS_FAILED/REMINDER/@WISELY/WEB';
export const FETCH_REMINDERS_SUCCEEDED = 'FETCH_REMINDERS_SUCCEEDED/REMINDER/@WISELY/WEB';
export const DELETE_REMINDER = 'DELETE_REMINDER/REMINDER/@WISELY/WEB';
export const DELETE_REMINDER_FAILED = 'DELETE_REMINDER_FAILED/REMINDER/@WISELY/WEB';
export const DELETE_REMINDER_SUCCEEDED = 'DELETE_REMINDER_SUCCEEDED/REMINDER/@WISELY/WEB';

export const clearReminders = () => ({
	type: CLEAR_REMINDERS,
});

export const getReminders = () => ({
	type: GET_REMINDERS,
});

export const fetchRemindersFailed = payload => ({
	type: FETCH_REMINDERS_FAILED,
	payload,
});

export const fetchRemindersSucceeded = payload => ({
	type: FETCH_REMINDERS_SUCCEEDED,
	payload,
});

export const fetchReminders = params => {
	return async dispatch => {
		dispatch(getReminders());
		const path = 'v2/reminders';

		return getHandler(path, params)
			.then(json => dispatch(fetchRemindersSucceeded(json)))
			.catch(error => {
				console.error('fetchReminders error', error);
				dispatch(fetchRemindersFailed(error));
			});
	};
};

export const deleteReminder = () => ({
	type: DELETE_REMINDER,
});

export const requestDeleteReminderFailed = payload => ({
	type: DELETE_REMINDER_FAILED,
	payload,
});

export const requestDeleteReminderSucceeded = payload => ({
	type: DELETE_REMINDER_SUCCEEDED,
	payload,
});

export const requestDeleteReminder = (id, params) => {
	return async (dispatch, getState) => {
		if (getPendingReminderDelete(getState())) {
			return;
		}
		dispatch(deleteReminder());
		const path = `v2/reminders/${id}`;

		return deleteHandler(path, params)
			.then(json => dispatch(requestDeleteReminderSucceeded(json)))
			.catch(error => {
				console.error('requestDeleteReminderFailed error', error);
				dispatch(requestDeleteReminderFailed(error));
			});
	};
};



// WEBPACK FOOTER //
// ./src/redux/reminders/reminder.action.js